import { render, staticRenderFns } from "./PsdSettingDialog.vue?vue&type=template&id=149ad1ec&scoped=true&"
import script from "./PsdSettingDialog.vue?vue&type=script&lang=ts&"
export * from "./PsdSettingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PsdSettingDialog.vue?vue&type=style&index=0&id=149ad1ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ad1ec",
  null
  
)

export default component.exports